import { render, staticRenderFns } from "./SemenIssue.vue?vue&type=template&id=3e59bbd6&scoped=true&"
import script from "./SemenIssue.vue?vue&type=script&lang=js&"
export * from "./SemenIssue.vue?vue&type=script&lang=js&"
import style0 from "./SemenIssue.vue?vue&type=style&index=0&id=3e59bbd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e59bbd6",
  null
  
)

export default component.exports